import { render } from "./HeadComponent.vue?vue&type=template&id=36031618&scoped=true"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=36031618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36031618"]])

export default __exports__